//@flow
import React, { Component } from 'react';
import {
  type Currencies,
  type Currency
  // type TooltipProps
} from '../../../utilities/types';
import { type TableRowOptionProps } from '..';
import TableRowDesktop from './Desktop/TableRowDesktop';
import TableRowDeviceRow1 from './Device/TableRowDeviceRow1';
import TableRowDeviceRow2 from './Device/TableRowDeviceRow2';
import { EmptyTableDiv, EmptyTableP } from '../StatisticsStyles';

type Props = {
  desktop?: boolean,
  deviceRow1?: boolean,
  deviceRow2?: boolean,
  toggleState?: string,
  partnerCurrency?: Currency,
  currencies?: Currencies,
  tableRowOptions: TableRowOptionProps,
  setToggleState?: () => void,
  hasProcessingSums: boolean
  // ...$Exact<TooltipProps>
};

export default class TableRow extends Component<Props> {
  render() {
    if (!this.props.hasProcessingSums) {
      return (
        <EmptyTableDiv>
          <EmptyTableP>No summary to show</EmptyTableP>
        </EmptyTableDiv>
      );
    }
    return (
      <>
        {this.props.desktop && (
          <TableRowDesktop
            toggleState={this.props.toggleState || ''}
            // $FlowFixMe
            setToggleState={this.props.setToggleState}
            partnerCurrency={this.props.partnerCurrency}
            currencies={this.props.currencies || {}}
            tableRowOptions={this.props.tableRowOptions}
          />
        )}
        {this.props.deviceRow1 && (
          <TableRowDeviceRow1 tableRowOptions={this.props.tableRowOptions} />
        )}
        {this.props.deviceRow2 && (
          <TableRowDeviceRow2
            toggleState={this.props.toggleState}
            // $FlowFixMe
            setToggleState={this.props.setToggleState}
            partnerCurrency={this.props.partnerCurrency}
            currencies={this.props.currencies}
            tableRowOptions={this.props.tableRowOptions}
          />
        )}
      </>
    );
  }
}
